var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrupo999(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 119.644,
    height: 106.204,
    viewBox: "0 0 119.644 106.204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_26",
    x: 0,
    y: 0,
    width: 119.644,
    height: 106.204,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.835,
    dy: 2.835,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.417,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#5b5b5b",
    floodOpacity: 0.349
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_27",
    x: 10.559,
    y: 9.281,
    width: 98.527,
    height: 87.642,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.835,
    dy: 2.835,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.417,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#5b5b5b",
    floodOpacity: 0.349
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_999",
    "data-name": "Grupo 999",
    transform: "translate(-792.09 -302.828)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 792.09, 302.83)",
    filter: "url(#Elipse_26)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_26-2",
    "data-name": "Elipse 26",
    cx: 55.57,
    cy: 48.85,
    rx: 55.57,
    ry: 48.85,
    transform: "translate(1.42 1.42)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 792.09, 302.83)",
    filter: "url(#Elipse_27)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_27-2",
    "data-name": "Elipse 27",
    cx: 45.012,
    cy: 39.569,
    rx: 45.012,
    ry: 39.569,
    transform: "translate(11.98 10.7)",
    fill: "#56af31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_201",
    "data-name": "Grupo 201",
    transform: "translate(817.939 326.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_583",
    "data-name": "Trazado 583",
    d: "M2189.014,6588.067c-16.867,0-30.59-12.064-30.59-26.891s13.723-26.891,30.59-26.891,30.59,12.063,30.59,26.891S2205.881,6588.067,2189.014,6588.067Zm0-49.453c-14.152,0-25.666,10.121-25.666,22.563s11.514,22.563,25.666,22.563,25.666-10.122,25.666-22.562S2203.166,6538.614,2189.014,6538.614Z",
    transform: "translate(-2158.424 -6534.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_584",
    "data-name": "Trazado 584",
    d: "M2189.013,6571.89a2.677,2.677,0,0,1-1.537-.473l-15.528-10.92a1.994,1.994,0,0,1-.385-3.043,2.7,2.7,0,0,1,3.46-.338l13.739,9.661,26.572-25.278a2.7,2.7,0,0,1,3.478-.12,1.986,1.986,0,0,1,.138,3.06l-28.128,26.757A2.623,2.623,0,0,1,2189.013,6571.89Z",
    transform: "translate(-2158.424 -6535.074)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupo999);
export default __webpack_public_path__ + "static/media/Grupo 999.a0b4b44f189814cfe9cb4e7f30883a3c.svg";
export { ForwardRef as ReactComponent };